import { render, staticRenderFns } from "./ModalGenerateInsuranceCompany.vue?vue&type=template&id=366a4141"
import script from "./ModalGenerateInsuranceCompany.vue?vue&type=script&lang=js"
export * from "./ModalGenerateInsuranceCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports